import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { userActionCreators } from '../../data/user/userActions';
import { UserState } from '../../data/user/userModels';
import './header.css';

// tslint:disable-next-line:no-var-requires
const logo = require('../../resources/NordfabLogo.png');

interface HeadState {
    header: HeaderState;
    user: UserState;
}

interface HeadActions {
    headerActions: typeof headerActionCreators;
    userActions: typeof userActionCreators;
}

/* tslint:disable */
type HeaderProps = HeadState & // ... state we've requested from the Redux store
    HeadActions & // ... plus action creators we've requested
    RouteComponentProps<{}>;

class Header extends React.Component<HeaderProps, {}> {
    constructor(props: HeaderProps) {
        super(props);

        this.state = {
            popoverOpen: false
        };
    }

    componentDidUpdate(prevProps: HeaderProps) {
        if (prevProps.user.name !== this.props.user.name) {
            this.forceUpdate();
        }
    }

    public render() {
        return (
            <div className="header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="headerLogoPadding">
                                <img src={logo} className="headerLogo" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dropHeaders" />
                <div className="headers">
                    <div className="topHeader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="float-right">
                                        <b>The World's Fastest Ducting</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="midHeader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="float-right">Hi {this.props.user.name}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottomHeader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="centerText slightIncrease nooverflow">
                                        <b>{this.props.header.bottomHeader}</b>
                                    </div>
                                </div>
                            </div>
                            <div className="menuBar summaryBar">
                                {this.props.user.permissions.fullAccess.read !== undefined &&
                                this.props.user.permissions.fullAccess.read === true ? (
                                    <nav className="nav justify-content-end summaryValue">
                                        <li className="nav-item summaryValue">
                                            Current Year to Date{' '}
                                            <b>
                                                {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                    minimumFractionDigits: 0
                                                }).format(
                                                    this.props.user.CustomerInformation.salesCurentYearToDate
                                                        ? this.props.user.CustomerInformation.salesCurentYearToDate
                                                        : 0
                                                )}
                                            </b>
                                        </li>
                                        |
                                        <li className="nav-item summaryValue">
                                            Previous Year To Date{' '}
                                            <b>
                                                {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                    minimumFractionDigits: 0
                                                }).format(
                                                    this.props.user.CustomerInformation.salesPreviousYear
                                                        ? this.props.user.CustomerInformation.salesPreviousYear
                                                        : 0
                                                )}
                                            </b>
                                        </li>
                                        |
                                        <li className="nav-item summaryValue">
                                            Previous Year Total{' '}
                                            <b>
                                                {new Intl.NumberFormat('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                    minimumFractionDigits: 0
                                                }).format(
                                                    this.props.user.CustomerInformation.salesPreviousYearToDate
                                                        ? this.props.user.CustomerInformation.salesPreviousYearToDate
                                                        : 0
                                                )}
                                            </b>
                                        </li>
                                        |
                                        {this.props.user.CustomerInformation.ranking != undefined &&
                                        this.props.user.CustomerInformation.ranking > 0 ? (
                                            <li className="nav-item summaryValue">
                                                <Badge className="badge-warning">
                                                    You are currently ranked no.{' '}
                                                    <b>{this.props.user.CustomerInformation.ranking}</b> in the{' '}
                                                    {this.props.user.CustomerInformation.territoryName != undefined
                                                        ? this.props.user.CustomerInformation.territoryName.replace(
                                                              'AM ',
                                                              ''
                                                          )
                                                        : ''}{' '}
                                                    territory
                                                </Badge>
                                            </li>
                                        ) : (
                                            <li></li>
                                        )}
                                    </nav>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): HeadState {
    return {
        header: state.header,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): HeadActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        userActions: bindActionCreators(userActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Header)
);



// WEBPACK FOOTER //
// ./src/containers/header/header.tsx